import { useGuestPrivilegeApi } from "../api/GuestPrivilegeApiClient";
import { GuestPrivilegeFrontendService } from "../services/GuestPrivilegeFrontendService";

export const useGuestPrivilegeService = (): GuestPrivilegeFrontendService =>
  new GuestPrivilegeFrontendService(useGuestPrivilegeApi());
